import React, { FunctionComponent } from 'react';

type Props = {
  keyword: string;
  onChangeKeyword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onSubmit: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  keyword,
  onChangeKeyword,
  handleSubmit,
  onSubmit,
}) => {
  return (
    <form className="tv-search" onSubmit={handleSubmit}>
      <label className="tv-search-label">
        <input
          type="text"
          name="keyword"
          value={keyword}
          onChange={onChangeKeyword}
          placeholder="キーワード / タグ検索"
          className="tv-search-label-input form-control notbeforeunload"
        />
        <span
          className="tv-search-label-icon"
          onClick={onSubmit}
        />
      </label>
    </form>
  );
};